import {
    FACEBOOK_MESSENGER_SERVICE_NAME,
    INSTAGRAM_MESSENGER_SERVICE_NAME,
    WHATSAPP_DISPLAY_NAME,
    TELEGRAM_SERVICE_NAME,
    SHOULD_HIDE_MESSENGER_CHANNELS,
} from "./AppConstants";

export const FIELD_MAPPING_SERVICE_PHONE = "phone";
export const FIELD_MAPPING_CONFIGURATION_VARIANT_PHONE = "phone";
export const FIELD_MAPPING_CONFIGURATION_VARIANT_SERVICE_RECIPIENT = "serviceRecipient";

const hideMessengerChannels = SHOULD_HIDE_MESSENGER_CHANNELS;

export const FIELD_MAPPING_SERVICE_TABS = [
  {
    key: FIELD_MAPPING_SERVICE_PHONE,
    label: "SMS/" + WHATSAPP_DISPLAY_NAME,
    serviceType: null,
    configurationVariant: FIELD_MAPPING_CONFIGURATION_VARIANT_PHONE,
    mappingTitle: "Phone Number Mapping",
    description:
      "Controls how HelloSend reads phone numbers from your CRM across campaigns, outbound, and inbox.",
    recipientFieldLabel: null,
    recipientFieldPlaceholder: "- Select -",
    notFoundContentText: "No phone field available.",
  },
  !hideMessengerChannels && {
    key: INSTAGRAM_MESSENGER_SERVICE_NAME,
    label: "Instagram",
    serviceType: INSTAGRAM_MESSENGER_SERVICE_NAME,
    configurationVariant: FIELD_MAPPING_CONFIGURATION_VARIANT_SERVICE_RECIPIENT,
    mappingTitle: "Recipient ID Mapping",
    description:
      "Choose where HelloSend stores the Instagram recipient ID inside your CRM. Lookup/related fields are not supported.",
    recipientFieldLabel: "Recipient ID Field",
    recipientFieldPlaceholder: "e.g., IG ID custom field",
    notFoundContentText: "No field available.",
  },
  !hideMessengerChannels && {
    key: FACEBOOK_MESSENGER_SERVICE_NAME,
    label: "Facebook",
    serviceType: FACEBOOK_MESSENGER_SERVICE_NAME,
    configurationVariant: FIELD_MAPPING_CONFIGURATION_VARIANT_SERVICE_RECIPIENT,
    mappingTitle: "Recipient ID Mapping",
    description:
      "Choose where HelloSend stores the Facebook Messenger recipient ID inside your CRM. Lookup/related fields are not supported.",
    recipientFieldLabel: "Recipient ID Field",
    recipientFieldPlaceholder: "e.g., Messenger PSID custom field",
    notFoundContentText: "No field available.",
  },
  {
    key: TELEGRAM_SERVICE_NAME,
    label: "Telegram",
    serviceType: TELEGRAM_SERVICE_NAME,
    configurationVariant: FIELD_MAPPING_CONFIGURATION_VARIANT_SERVICE_RECIPIENT,
    mappingTitle: "Recipient ID Mapping",
    description:
      "Choose where HelloSend stores the Telegram recipient ID inside your CRM. Lookup/related fields are not supported.",
    recipientFieldLabel: "Recipient ID Field",
    recipientFieldPlaceholder: "e.g., Telegram Chat ID custom field",
    notFoundContentText: "No field available.",
  },
]?.filter(Boolean);

export const getFieldMappingTabConfig = (serviceTabKey) =>
  FIELD_MAPPING_SERVICE_TABS.find((serviceTab) => serviceTab.key === serviceTabKey);

export const isMessengerFieldMappingService = (serviceType) =>
  Boolean(serviceType && serviceType !== FIELD_MAPPING_SERVICE_PHONE);
